import { render, staticRenderFns } from "./Initialize.vue?vue&type=template&id=2aa58fb0&"
import script from "./Initialize.vue?vue&type=script&lang=js&"
export * from "./Initialize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports